export enum LdReportType {
  LeakDetection = 'LEAK_DETECTION',
  Correlation = 'CORRELATION',
  Measurement = 'MEASUREMENT',
  NoiseEvent = 'NOISE_EVENT',
  SoundBlockValues = 'SOUND_BLOCK_VALUES',
}
